"use client";

import { useRef } from "react";
import { Image } from "@heroui/image";
import SGE2 from "public/SGE2.png";

interface DashboardHeaderProps {
  countryName?: string;
  countryFlag?: string;
  branchName?: string;
  branchLogo?: string;
  userName?: string;
  userTitle?: string;
  userAvatar?: string;
}

export default function DashboardHeader({
  countryName = "The Federal Republic of Nigeria",
  branchName = "Ministry of Livestock Development",
  branchLogo = "https://cdn.prod.website-files.com/637272306337381b5223282b/63b94d8f1ee9c625822891ae_image%202%20(4)%201%20(1).png",
  // userName = "Sarah Johnson",
  // userTitle = "Deputy Director of
  // Operations", userAvatar =
  // "/placeholder.svg?height=40&width=40",
}: DashboardHeaderProps) {
  const headerRef = useRef<HTMLDivElement>(null);
  const flagRef = useRef<HTMLDivElement>(null);
  const logoRef = useRef<HTMLDivElement>(null);
  const titleRef = useRef<HTMLDivElement>(null);
  const gradientRef = useRef<HTMLDivElement>(null);

  return (
    <header
      ref={headerRef}
      className="container relative bg-white border-b border-gray-200 overflow-hidden"
    >
      {/* Animated gradient background */}
      <div ref={gradientRef} className="absolute inset-0 opacity-5" />

      {/* Decorative elements */}
      {/* <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-600 via-blue-500 to-blue-600" /> */}

      <div className="relative z-10 px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <Image
            alt="SilaGenetics Logo"
            className="absolute top-0 left-0 w-20 h-20 object-cover opacity-10"
            src={SGE2}
          />
          {/* Left section - Country and Branch Info */}
          <div className="flex items-center space-x-4 lg:space-x-6">
            {/* Country Flag */}
            <div ref={flagRef} className="flex-shrink-0 cursor-pointer">
              <div className="relative">
                {/* <img */}
                {/*   alt={`${countryName} flag`} */}
                {/*   className="h-8 w-12 lg:h-10 lg:w-15 object-cover rounded shadow-md border border-gray-300" */}
                {/*   src={countryFlag || "/placeholder.svg"} */}
                {/* /> */}
                <svg
                  className="w-12 h-12"
                  enableBackground="new 0 0 512 512"
                  viewBox="0 0 512 512"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="256" cy="256" fill="#f0f0f0" r="256" />
                  <g fill="#6da544">
                    <path d="m0 256c0 110.072 69.472 203.906 166.957 240.078v-480.154c-97.485 36.17-166.957 130.006-166.957 240.076z" />
                    <path d="m512 256c0-110.07-69.472-203.906-166.957-240.076v480.155c97.485-36.173 166.957-130.007 166.957-240.079z" />
                  </g>
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                  <g />
                </svg>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 hover:opacity-20 transition-opacity duration-300 rounded" />
              </div>
            </div>

            {/* Vertical Divider */}
            <div className="hidden sm:block h-8 lg:h-10 w-px bg-gradient-to-b from-transparent via-gray-300 to-transparent" />

            {/* Branch Logo */}
            <div ref={logoRef} className="flex-shrink-0 cursor-pointer">
              <img
                alt={`${branchName} logo`}
                className="h-8 w-8 lg:h-10 lg:w-10 object-contain"
                src={branchLogo || "/placeholder.svg"}
              />
            </div>

            {/* Title Section */}
            <div ref={titleRef} className="hidden md:block">
              <div className="flex flex-col">
                <h1 className="text-sm lg:text-base font-bold text-gray-900 leading-tight">
                  {countryName}
                </h1>
                <p className="text-xs lg:text-sm text-gray-600 font-medium">
                  {branchName}
                </p>
              </div>
            </div>
          </div>

          {/* Right section - User Info and Actions */}
          {/* <div className="flex items-center space-x-3 lg:space-x-4"> */}
          {/*   /!* Vertical Divider *!/ */}
          {/*   <div className="h-8 w-px bg-gradient-to-b from-transparent via-gray-300 to-transparent" /> */}

          {/*   /!* User Profile Dropdown *!/ */}
          {/*   <DropdownMenu> */}
          {/*     <DropdownMenuTrigger asChild> */}
          {/*       <Button */}
          {/*         className="flex items-center space-x-3 p-2 hover:bg-gray-100 transition-all duration-200 rounded-lg" */}
          {/*         variant="ghost" */}
          {/*       > */}
          {/*         <div className="flex items-center space-x-3"> */}
          {/*           <div className="relative"> */}
          {/*             <img */}
          {/*               alt={userName} */}
          {/*               className="h-8 w-8 lg:h-10 lg:w-10 rounded-full object-cover border-2 border-blue-200" */}
          {/*               src={userAvatar || "/placeholder.svg"} */}
          {/*             /> */}
          {/*             <div className="absolute -bottom-1 -right-1 h-3 w-3 bg-green-500 border-2 border-white rounded-full" /> */}
          {/*           </div> */}
          {/*           <div className="hidden lg:block text-left"> */}
          {/*             <p className="text-sm font-semibold text-gray-900 leading-tight"> */}
          {/*               {userName} */}
          {/*             </p> */}
          {/*             <p className="text-xs text-gray-600 leading-tight max-w-32 truncate"> */}
          {/*               {userTitle} */}
          {/*             </p> */}
          {/*           </div> */}
          {/*           <ChevronDown className="h-4 w-4 text-gray-500" /> */}
          {/*         </div> */}
          {/*       </Button> */}
          {/*     </DropdownMenuTrigger> */}
          {/*     <DropdownMenuContent align="end" className="w-56"> */}
          {/*       <div className="px-3 py-2 border-b"> */}
          {/*         <p className="text-sm font-medium text-gray-900"> */}
          {/*           {userName} */}
          {/*         </p> */}
          {/*         <p className="text-xs text-gray-600">{userTitle}</p> */}
          {/*       </div> */}
          {/*       <DropdownMenuItem className="cursor-pointer"> */}
          {/*         <Settings className="mr-2 h-4 w-4" /> */}
          {/*         Account Settings */}
          {/*       </DropdownMenuItem> */}
          {/*       <DropdownMenuItem className="cursor-pointer"> */}
          {/*         <Bell className="mr-2 h-4 w-4" /> */}
          {/*         Notifications */}
          {/*       </DropdownMenuItem> */}
          {/*       <DropdownMenuSeparator /> */}
          {/*       <DropdownMenuItem className="cursor-pointer text-red-600 focus:text-red-600"> */}
          {/*         <LogOut className="mr-2 h-4 w-4" /> */}
          {/*         Sign Out */}
          {/*       </DropdownMenuItem> */}
          {/*     </DropdownMenuContent> */}
          {/*   </DropdownMenu> */}
          {/* </div> */}
        </div>
      </div>

      {/* Bottom gradient line */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-blue-300 to-transparent" />
    </header>
  );
}
